module.exports = __webpack_public_path__ + "static/media/responsive.e21c7549.svg";